module.exports = __webpack_public_path__ + "img/side-btn.df2d4486.svg";